/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiProjectstatuses200Schema = z.any();

export const postApiProjectstatusesMutationRequestSchema = z.object({
  name: z.coerce.string(),
});

export const postApiProjectstatusesMutationResponseSchema = z.lazy(
  () => postApiProjectstatuses200Schema,
);
